import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import each from "lodash/each"
import takeRight from "lodash/takeRight"
import _map from "lodash/map"

export default class ErrorSuccessHistogramChart extends Component {
  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    this.chart = new Highcharts.Chart({
      chart: {
        animation: false,
        renderTo: this.chartContainer,
        type: "column",
        height: 250,
        spacing: [10, 0, 10, 0],
      },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      credits: { enabled: false },
      tooltip: {
        formatter() {
          let s = '<span style="color: #999">' + this.x + "</span>"
          each(this.points, p => {
            s +=
              "<br>" +
              p.series.name +
              ": <b>" +
              (p.y * 100).toFixed(3) +
              "%</b>"
          })

          return s
        },
        animation: false,
        backgroundColor: "#333",
        borderWidth: 0,
        borderRadius: 10,
        padding: 10,
        shadow: false,
        shared: true,
        style: {
          color: "#fff",
          fontSize: 14,
        },
      },
      plotOptions: {
        column: {
          stacking: "percent",
          groupPadding: 0,
          pointPadding: 0,
          borderWidth: 0,
          shadow: false,
        },
      },
      series: [
        {
          name: "Error",
          color: "#e43",
        },
        {
          name: "Success",
          color: "#70d600",
        },
      ],
      xAxis: {
        type: "datetime",
        tickmarkPlacement: "on",
        labels: {
          step: 8,
          margin: 10,
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        offset: 10,
        gridLineWidth: 4,
        gridLineColor: "#f5f5f5",
        lineWidth: 0,
        showLastLabel: false,
        tickWidth: 0,
      },
      yAxis: {
        title: {
          enabled: false,
        },
        min: 0,
        max: 100,
        labels: {
          format: "{value}%",
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        gridLineWidth: 0,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 483,
            },
            chartOptions: {
              series: [
                {
                  data: takeRight(this.errorSerie(), 25),
                  pointWidth: 8,
                },
                {
                  data: takeRight(this.successSerie(), 25),
                  pointWidth: 8,
                },
              ],
              xAxis: {
                categories: takeRight(this.timeIntervalSerie(), 25),
              },
            },
          },
          {
            condition: {
              minWidth: 484,
            },
            chartOptions: {
              series: [
                {
                  data: takeRight(this.errorSerie(), 50),
                  pointWidth: 8,
                },
                {
                  data: takeRight(this.successSerie(), 50),
                  pointWidth: 8,
                },
              ],
              xAxis: {
                categories: takeRight(this.timeIntervalSerie(), 50),
              },
            },
          },
        ],
      },
    })
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  timeIntervalSerie() {
    return _map(this.props.data, n => {
      return moment.unix(n.timestamp / 1000).format("h:mm A")
    })
  }

  errorSerie() {
    return _map(this.props.data, n => {
      return n.ratio === -1 ? 0 : 1 - n.ratio
    })
  }

  successSerie() {
    return _map(this.props.data, n => {
      return n.ratio === -1 ? 0 : n.ratio
    })
  }

  render() {
    return (
      <div className="chart-container" ref={c => (this.chartContainer = c)} />
    )
  }
}

ErrorSuccessHistogramChart.propTypes = {
  data: PropTypes.array.isRequired,
}
